import { authCookieConfig } from "@/utils/base";
import { setServiceVal } from "@/utils/cookies";

const initState = {
  scrollDirection: "", //down-up-向上滚
  scrollHeight: 0, //滚动高度
  scrollDistance: 0, //滚动距离
  isClickCauseScroll: false, //是否点击导致滚动
  userDataChange: 0,
  userData: {},
  portalAuthorization: {
    accessToken: '',
    expireTime: ''
  },
  releaseDetail: null, // 上架审核详情
  docsIframe: null, // 文档iframe
};
interface Action {
  type: string;
  payload: any;
}
//接受state,传递过来的action
const portal = (state = initState, action: Action) => {
  const { type, payload } = action;
  switch (type) {
    case "setScrollDirection":
      return { ...state, scrollDirection: payload };
    case "setScrollHeight":
      return { ...state, scrollHeight: payload };
    case "setScrollDistance":
      return { ...state, scrollDistance: payload };
    case "setIsClickCauseScroll":
      return { ...state, isClickCauseScroll: payload };
    case "setUserDataChange":
      return { ...state, userDataChange: payload };
    case "setUserData":
      return { ...state, userData: payload };
    case "setPortalAuthorization":
      // eslint-disable-next-line no-case-declarations
      const { portalAuthorization } = state;
      // eslint-disable-next-line no-case-declarations
      const result = {
        ...portalAuthorization,
        ...payload
      };
      console.log(result);
      setServiceVal('Authorization', result.accessToken, {
        expires: result.expireTime ? result.expireTime / (1000 * 60 * 60 * 24) : authCookieConfig.expires,
        path: authCookieConfig.path,
        domain: authCookieConfig.domain
      });
      return { ...state, portalAuthorization: payload };
    case "setReleaseDetail":
      return { ...state, releaseDetail: payload };
    case "setDocsIframe":
      return { ...state, docsIframe: payload };
    default:
      return state;
  }
};

export default portal;
